





































import { mapState } from "vuex";
import { Component, Prop, Mixins } from "vue-property-decorator";
import TermsAndConditionsMixin from "@/components/app/global/termsAndConditions/termsAndConditionsMixin";

@Component({
  components: {
    "terms-and-ctermsAndConditionstermsAndConditionsonditions": () =>
      import(
        "@/components/app/admin/settings/billing/termsAndConditionsDetails.vue"
      )
  },
  computed: {
    ...mapState({
      brandId: (state: any) => state.auth.admin.brandId
    })
  }
})
export default class TermsAndConditionsModal extends Mixins(
  TermsAndConditionsMixin
) {
  @Prop({ required: false, default: true })
  public allowCopy!: boolean;

  @Prop({ required: false, default: "_action.close" })
  public cancelText!: string;

  public copyToClipboard() {
    this.$copyToClipboard(
      this.isUrl ? this.tAndC.terms.url : this.tAndC.terms.terms
    );
  }
}
